/**
 * Display label for tonnage cost-class keys.
 * Canonical rate key stays `Artic`; managers see Payload 44T (same as Config).
 */
export function displayTonnageClass(label: string): string {
  return label === 'Artic' ? '44T' : label;
}
